<loading *ngIf="isSubmitting"></loading>
<div class="correction-form">
  <aside class="correction-form__aside correction-aside">
    <h1 class="correction-aside__heading">Just a couple more questions...</h1>
    <p class="correction-aside__body-text">
      We're having trouble verifying some of {{ subjectString }} information. Please confirm these details are correct
      so we can process your application.
    </p>
    <div class="correction-aside__divider"></div>
  </aside>
  <div class="correction-form__divider"></div>
  <div *ngIf="!showLegalInfoQuestions" class="correction-form__application">
    <ssn-correction-form
      *ngIf="correctionType === 'ssn'"
      (toggleLoadingSpinner)="toggleSpinner($event)"
      (submitCorrection)="submitCorrection()"
      (showLegalInfoPage)="flipPage()"
      (zipChanged)="setZip($event)"
      [personType]="personType"
    ></ssn-correction-form>
    <license-correction-form
      *ngIf="correctionType === 'license'"
      (toggleLoadingSpinner)="toggleSpinner($event)"
      (submitCorrection)="submitCorrection()"
      (zipChanged)="setZip($event)"
      [personType]="personType"
    ></license-correction-form>
  </div>
  <div *ngIf="showLegalInfoQuestions" class="correction-form__application">
    <legal-info-correction-form
      (toggleLoadingSpinner)="toggleSpinner($event)"
      (submitCorrection)="submitCorrection()"
    ></legal-info-correction-form>
  </div>
</div>
